import { useQueryClient, useMutation, useQuery } from 'react-query'

import { Report13CreateFormTypes, } from "schemas/reports-#-13-schemas";
import { postReport13Service } from "api/reports-#-13";

export const useReport13Query = (payload: Report13CreateFormTypes) => {
  const query = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useReport13Query', payload],
    queryFn: async () => {
      return await postReport13Service(payload);
    },
  })
  
  return query;
}

export const useReport13Mutation = () => {
  // const queryClient = useQueryClient();
  
  const mutationFn = async (payload: Report13CreateFormTypes) => {
    return await postReport13Service(payload);
  };

  const mutation = useMutation({
    mutationFn,
    // onError: (error: string) => {},
    // onSuccess: (data) => {},
  });

  return mutation;
};
